export default function VoIPKeyBenefits() {
    const benefits = [
        {
            title: "No extra hardware",
            description: "Dialpad works on all your favorite devices. We're talking smartphones, laptops, tablets—everything. All you need is the app."
        },
        {
            title: "Easy, fast setup",
            description: "Get your system and new business line up and running in no time, so you can focus on growing your business."
        },
        {
            title: "Built to scale",
            description: "Our cloud platform is designed to scale as you grow. From your first phone line to that new office, we've got you covered."
        }
    ];

    return (
        <section className="pb-20 pt-10 lg:py-24 relative overflow-hidden">
            <div className="container">
                {/* Main heading */}
                <div className="mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 max-w-5xl">
                        Forget about traditional handset for businesses
                    </h2>
                    
                    {/* Black banner with description */}
                    <div className="bg-black rounded-2xl p-8 md:p-12 border border-purple-500/20">
                        <p className="text-white text-lg md:text-xl lg:text-2xl leading-relaxed">
                            Our AI-powered business phone system replaces outdated office phone systems with a modern, cloud-based solution trusted across{' '}
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400">
                                Australia
                            </span>
                            .
                        </p>
                    </div>
                </div>

                {/* Benefits Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="group">
                            <div className="bg-gradient-to-br from-purple-600/5 to-blue-600/5 rounded-2xl p-8 border border-purple-500/20 hover:border-purple-500/50 transition-all duration-300 h-full">
                                <h3 className="text-2xl font-bold text-white mb-4">
                                    {benefit.title}
                                </h3>
                                <p className="text-gray-300 text-base leading-relaxed">
                                    {benefit.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}